// @flow
import topics from './topics'
import { WIDGET_ID } from '../constants'
import { type MessageBusType } from './messageBus'

type OnStartCallbackPropsType = {
  selector: string,
  metadata: {
    [string]: string,
  },
}
type OnStartCallbackType = (props: OnStartCallbackPropsType) => Promise<void>
type OnStopCallbackType = () => void

// Destructing topics
const { INIT_ERROR, INIT_SUCCESS, START, STOP, STOP_SUCCESS, STOP_ERROR, START_SUCCESS, START_ERROR } = topics

const integratorFactory = (messageBus: MessageBusType, hasStartedDefault: boolean = false) => {
  let hasStarted: boolean = hasStartedDefault

  // Subscriptions
  const onStart = (callback: OnStartCallbackType): void => {
    messageBus.subscribe(START, async (_, { id, selector, metadata }) => {
      if (WIDGET_ID === id) {
        try {
          if (hasStarted) {
            throw Error(`${WIDGET_ID}: Widget has already started`)
          }

          await callback({ selector, metadata })
          messageBus.publish(START_SUCCESS, { id: WIDGET_ID })
          hasStarted = true
        } catch (e) {
          messageBus.publish(START_ERROR, { id: WIDGET_ID, reason: e.message })
        }
      }
    })
  }

  const onStop = (callback: OnStopCallbackType): void => {
    messageBus.subscribe(STOP, async (_, { id }) => {
      if (WIDGET_ID === id) {
        try {
          if (!hasStarted) {
            throw Error(`${WIDGET_ID}: Widget hasn't been started`)
          }

          await callback()
          messageBus.publish(STOP_SUCCESS, { id: WIDGET_ID })
          hasStarted = false
        } catch (e) {
          messageBus.publish(STOP_ERROR, { id: WIDGET_ID, reason: e.message })
        }
      }
    })
  }

  // Publish
  const initSuccess = (): void => messageBus.publish(INIT_SUCCESS, { id: WIDGET_ID })
  const initError = (e: Error): void => messageBus.publish(INIT_ERROR, { id: WIDGET_ID, reason: e.message })

  return { onStop, onStart, initSuccess, initError }
}

export default integratorFactory
